<template>
  <VirtualDeviceItem
    :group="group"
    :device="device"
    deviceType="1"
    :selectedDevices="selectedDevices"
    :selectable="true"
    @deviceChecked="(data) => emit('deviceChecked', data)"
    @onDeviceChecked="(data) => emit('deviceChecked', data)"
    @showStateChanged="(data) => emit('showStateChanged', data)"
  />
</template>

<script setup>
import VirtualDeviceItem from './VirtualDeviceItem.vue';

defineProps(['group', 'device', 'selectedDevices']);
const emit = defineEmits(['deviceChecked', 'showStateChanged']);
</script>
